var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M903 11.6229V240H-135V11.6229C-86.228 57.3943 -30.6993 78.8229 32.3065 78.8229C145.422 78.8229 190.867 33.5314 280.728 11.6229C309.401 4.62857 342.602 0 384 0C425.398 0 458.598 4.62857 487.272 11.6229C577.133 33.5314 622.578 78.8229 735.693 78.8229C798.699 78.8229 854.228 57.3943 903 11.6229Z",
    fill: "#F7F8F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWave);
export default __webpack_public_path__ + "static/media/background-wave.f8f58bb8798260d59ce39dfb394917ec.svg";
export { ForwardRef as ReactComponent };